import { isValidPhone, phoneHasWhitespace, PHONE_NO_SPACE_MSG } from '@/utils/phoneValidate.js'

function createPhoneValidator () {
  return (rule, value) => {
    if (!value) {
      return Promise.reject('请输入手机号')
    }
    if (phoneHasWhitespace(value)) {
      return Promise.reject(PHONE_NO_SPACE_MSG)
    }
    if (!isValidPhone(value)) {
      return Promise.reject('请输入正确的手机号')
    }
    return Promise.resolve()
  }
}

export function createPasswordFormRules () {
  const validatePhone = createPhoneValidator()
  return {
    mobile: [
      { required: true, validator: validatePhone, trigger: 'blur' }
    ],
    loginpass: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
    ]
  }
}

export function createSmsFormRules () {
  const validatePhone = createPhoneValidator()
  return {
    mobile: [
      { required: true, validator: validatePhone, trigger: 'blur' }
    ],
    code: [
      { required: true, message: '请输入验证码', trigger: 'blur' },
      { min: 4, message: '验证码格式不正确', trigger: 'blur' }
    ]
  }
}
